import React, { useState } from "react";
import styled, { keyframes, css } from "styled-components";

// Shimmer animation like MUI's Skeleton
const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`;

// Skeleton container with shimmer effect
const Skeleton = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #e0e0e0;
  background-image: linear-gradient(
    90deg,
    #e0e0e0 0px,
    #f5f5f5 40px,
    #e0e0e0 80px
  );
  background-size: 200px 100%;
  background-repeat: no-repeat;
  animation: ${shimmer} 1.2s infinite ease-in-out;
  border-radius: inherit;
  aspect-ratio:1;
  overflow:hidden;
`;

// Container for image + skeleton
const Wrapper = styled.div`
  position: relative;
  width: ${({ width }) => width || "100%"};
  height: ${({ height }) => height || "auto"};
  overflow: hidden;
  border-radius: ${({ radius }) => radius || "0px"};
`;

// Image with fade-in transition
const StyledImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: ${({ loaded }) => (loaded ? 1 : 0)};
  transition: opacity 0.5s ease-in-out;
  display: block;
  aspect-ratio:1;
`;

const ImageWithSkeleton = ({ src, alt, width, height, radius }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <Wrapper width={width} height={height} radius={radius}>
      {!loaded && <Skeleton />}
      <StyledImg
        src={src}
        alt={alt}
        onLoad={() => setLoaded(true)}
        loaded={loaded}
      />
    </Wrapper>
  );
};

export default ImageWithSkeleton;
